import { OutboundLink } from 'gatsby-plugin-google-analytics';
import PropTypes from 'prop-types';
import React from 'react';

const ExternalLink = React.forwardRef(function ExternalLink(
  { link, children, ...props },
  ref
) {
  return (
    <OutboundLink
      ref={ref}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    >
      {children}
    </OutboundLink>
  );
});

ExternalLink.propTypes = {
  link: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default ExternalLink;
